"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.arrowHeight = void 0;
var arrowHeight = 8;
exports.arrowHeight = arrowHeight;
var arrowWidth = 5;

var _default = function _default(theme) {
  return {
    Arrow: {
      position: 'absolute',
      width: 0,
      height: 0,
      borderColor: 'transparent',
      borderStyle: 'solid'
    },
    Left: {
      borderLeftColor: theme['$popover-background'],
      borderWidth: "".concat(arrowWidth, "px 0 ").concat(arrowWidth, "px ").concat(arrowHeight, "px"),
      right: -arrowHeight,
      bottom: '50%',
      margin: {
        top: -arrowWidth,
        bottom: -arrowWidth
      }
    },
    Right: {
      borderRightColor: theme['$popover-background'],
      borderWidth: "".concat(arrowWidth, "px ").concat(arrowHeight, "px ").concat(arrowWidth, "px 0"),
      left: -arrowHeight,
      bottom: '50%',
      margin: {
        top: -arrowWidth,
        bottom: -arrowWidth
      }
    },
    Top: {
      borderTopColor: theme['$popover-background'],
      borderWidth: "".concat(arrowHeight, "px ").concat(arrowWidth, "px 0"),
      bottom: -arrowHeight,
      left: '50%',
      margin: {
        left: -arrowWidth,
        right: -arrowWidth
      }
    },
    Bottom: {
      borderBottomColor: theme['$popover-background'],
      borderWidth: "0 ".concat(arrowWidth, "px ").concat(arrowHeight, "px"),
      top: -arrowHeight,
      left: '50%',
      margin: {
        left: -arrowWidth,
        right: -arrowWidth
      }
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=Arrow.style.js.map